<template>
  <el-card class="box-card">
    <div slot="header" class="card-head">
      <div>待收货清单</div>
      <div style="display: flex;align-items: center;justify-content: flex-end;">
        <el-button type="primary" size="mini" @click="doReceive">收货</el-button>
        <el-button size="mini"  icon="el-icon-refresh" @click="$refs.StoreLogTable.reload()">刷新</el-button>
      </div>
    </div>
    <StoreLogTable ref="StoreLogTable" query-type="receiver" :hide-buttons="['back']" :table-height="500"
                   :show-query-bar="false" :has-page="false"
                   :hide-columns="['receiverName','receipt','receiveOptTime','receiveOptManName','price','count','backCount']"
                   :default-query-params="{status:10,page:1,limit:10000}"></StoreLogTable>
  </el-card>
</template>

<script>
import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'

export default {
  name: 'wait-receiver-card',
  components: { StoreLogTable },
  methods: {
    doReceive () {
      this.$refs.StoreLogTable.showReceiveDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-card__body{
  padding: 10px;
}
</style>
